var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('nav-bar',{attrs:{"title":"活动规则"}}),_c('div',{staticClass:"rule",domProps:{"innerHTML":_vm._s(_vm.rule)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }